export default __webpack_public_path__ + "static/media/inner2.e3009d85.jpg";